module.exports = __webpack_public_path__ + "static/media/LOGO-FERRAGENS.9425d788.png";